// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as SettingsBDefault } from '../../../assets/icons/default/general/settings-b.svg?react';
import { ReactComponent as SettingsBSolid } from '../../../assets/icons/solid/general/SETTINGS-B.svg?react';
import { createIcons } from '../../Icon';
const SettingsBIcon = /* @__PURE__ */ createIcons('SettingsB', {
    default: SettingsBDefault,
    solid: SettingsBSolid
});
SettingsBIcon.supportedTypes = ['default', 'solid'];
SettingsBIcon.category = 'general';
export default SettingsBIcon;
